import { render, staticRenderFns } from "./AuditLogsTable.vue?vue&type=template&id=3912fd48"
import script from "./AuditLogsTable.vue?vue&type=script&lang=js"
export * from "./AuditLogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports